import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { useNavigateAndScroll } from '../Hooks/useNavigateAndScroll';

const InfoCard = ({ image, infoTitle, infoText, path, onNavigate }) => {

  const navigateAndScroll = useNavigateAndScroll();

  const handleNavigation = () => {
    if (onNavigate) {
      onNavigate(path);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden max-w-lg mx-auto hover:shadow-xl transition-shadow duration-300">
      <div className="flex h-80 w-auto">
        {/* Left side - Image */}
        <div className="w-2/5 relative">
          <img 
            src={image} 
            alt={infoTitle}
            className="w-full h-full object-cover"
          />
          {/* Gradient overlay for blending */}
          <div className="absolute top-0 right-0 w-8 h-full bg-gradient-to-l from-white to-transparent"></div>
        </div>
        
        {/* Right side - Info */}
        <div className="w-3/5 p-6 flex flex-col justify-between relative">
          {/* Header with title and button */}
          <div className="flex justify-between items-start mb-4">
            <h3 className="text-lg font-semibold text-gray-800 pr-2 leading-tight">
              {infoTitle}
            </h3>
            <button
              onClick={() => navigateAndScroll(path)}
              className="bg-blue-500 hover:bg-blue-600 text-white rounded-full p-2 flex-shrink-0 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              aria-label={`Learn more about ${infoTitle}`}
            >
              <ArrowUpRight size={16} />
            </button>
          </div>
          
          {/* Info text - centered in remaining space */}
          <div className="flex-1 flex items-center">
            <p className="text-gray-600 text-sm leading-relaxed">
              {infoText}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};


export default InfoCard;